module.exports = __webpack_public_path__ + "static/media/instagram.eeb5389b.svg";